import { FEATURE } from './CONSTANTS';

const hasAnalyticsFeature = () => window.teamFeatures && window.teamFeatures.includes(FEATURE.ANALYTICS);

const hasGroupFeature = () => window.teamFeatures && window.teamFeatures.includes(FEATURE.GROUPS);

const hasVerificationFeature = () => window.teamFeatures && window.teamFeatures.includes(FEATURE.VERIFICATION);

const hasSlackFeature = () => window.teamFeatures && window.teamFeatures.includes(FEATURE.SLACK);

const hasPrivateCategories = () => window.teamFeatures && window.teamFeatures.includes(FEATURE.PRIVATE_CATEGORY);

const hasPublicCategories = () => window.teamFeatures && window.teamFeatures.includes(FEATURE.PUBLIC_CATEGORY);

const hasSuggestEditFeature = () => window.teamFeatures && window.teamFeatures.includes(FEATURE.SUGGEST_EDIT);

const hasExternalSiteFeature = () => window.teamFeatures && window.teamFeatures.includes(FEATURE.EXTERNAL_SITES);

const hasKaiFeature = () => window.teamFeatures && window.teamFeatures.includes(FEATURE.KAI);

const hasSlackQAFeature = () => window.teamFeatures && window.teamFeatures.includes(FEATURE.SLACK_QA);

export {
    hasAnalyticsFeature,
    hasGroupFeature,
    hasVerificationFeature,
    hasPrivateCategories,
    hasPublicCategories,
    hasSlackFeature,
    hasSuggestEditFeature,
    hasExternalSiteFeature,
    hasKaiFeature,
    hasSlackQAFeature,
};
